import { GetAllReportsReq, GetAllReportsRes, NewReportReq, NewReportRes } from "../interfaces/report.interface";
import { API } from "./api";

export const getAllReportsService = async (data: GetAllReportsReq): Promise<GetAllReportsRes>=>{
    try {
        const res = await API.get(`/v1/report` );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const newReportService = async (data: NewReportReq): Promise<NewReportRes>=>{
    try {
        const res = await API.post(`/v1/report`, data);
        return res.data;
    } catch (error) {
        throw error
    }
}

